import { render, staticRenderFns } from "./DatasetsResult.vue?vue&type=template&id=7eb7616c&"
import script from "./DatasetsResult.vue?vue&type=script&lang=js&"
export * from "./DatasetsResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports